<template>
<v-container>
	<v-row>	
	<v-col cols="3"   class="text-center"></v-col>
<v-col cols="6"   class="text-center">
	<qr-code   
	 style="    display: inline-block;"
	size="150"  
 :text="`https://menu-qr.web.app/i/${bussinessId}`"></qr-code>
</v-col>
<v-col cols="3"   class="text-center"></v-col>
	</v-row>
	<v-row justify-sm="center"   style="padding-top: 10px;"  >
		
		<v-col cols="12"   class="text-center">
			<v-spacer ></v-spacer>
			
		
			
			<h2 class="font" v-html="bussiness.name"></h2>
			<h2 class="font" >· Carta Digital ·</h2>
			<v-spacer ></v-spacer>
		</v-col>
		<v-col class="mt-12 text-center ">
			<h2 class="font_s" >menu-qr.net</h2>
			<h4 class="font_s" >by Uebs App Lab </h4>
		</v-col>
	</v-row>
</v-container>
</template>

<script>
import { mapState } from "vuex";

	export default {
		name: 'Splash',
		computed: {
			...mapState(['bussiness','collectionFound','bussinessId']),
			
		}	
	}
</script>


<style scoped>
	font {
		font-family: 'Roboto', sans-serif;
		font-weight: 400;
		line-height: normal !important;
	}
		.font_s {
		font-family: 'Roboto', sans-serif;
		font-weight: 200;
		line-height: normal !important;
	}

</style>